import {
  authCard,
  buttonBlock,
  buttonPrimary,
  colors,
  fonts,
  thinScrollbar,
} from '../../theme';

const ladderPoints = {
  fontFamily: fonts.text,
  fontSize: 13,
  fontWeight: 500,
  color: colors.textSecondary,
};

const styles = {
  dialog: {
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.72)',
    },
  },
  paper: {
    ...authCard,
    ...thinScrollbar,
    position: 'relative',
    width: { xs: 'calc(100% - 32px)', sm: 440 },
    maxWidth: 'none',
    maxHeight: 'calc(100% - 32px)',
    m: 0,
    p: 3,
    boxSizing: 'border-box',
    backgroundImage: 'none',
    boxShadow: '0 24px 64px rgba(0, 0, 0, 0.7)',
  },
  // The content is laid out by the paper itself (padding and scrollbar).
  content: {
    p: 0,
    overflow: 'visible',
  },
  close: {
    position: 'absolute',
    top: 8,
    right: 8,
    color: colors.textSecondary,
    '&:hover': {
      color: colors.text,
      backgroundColor: colors.surfaceRaised,
    },
  },
  title: {
    pr: 4,
    fontFamily: fonts.text,
    fontSize: 18,
    fontWeight: 700,
    color: colors.text,
  },
  description: {
    mt: 1,
    fontFamily: fonts.text,
    fontSize: 13.5,
    lineHeight: 1.5,
    color: colors.textSecondary,
  },
  pointsGrid: {
    mt: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
  },
  pointsRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
    gap: 1,
  },
  pointsCell: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 0.25,
    // No box: same background as the dialog, as in the app.
    py: 1,
  },
  pointsTop: {
    fontFamily: fonts.text,
    fontSize: 11,
    color: colors.textSubtle,
  },
  pointsValue: {
    fontFamily: fonts.text,
    fontSize: 15,
    fontWeight: 700,
    color: colors.text,
  },
  ladder: {
    mt: 2,
    borderRadius: '10px',
    border: `1px solid ${colors.border}`,
    overflow: 'hidden',
  },
  ladderRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 2,
    px: 1.5,
    py: 1.25,
    '& + &': {
      borderTop: `1px solid ${colors.border}`,
    },
  },
  ladderPoints,
  ladderPointsCurrent: {
    ...ladderPoints,
    fontWeight: 700,
    color: colors.text,
  },
  button: {
    ...buttonPrimary,
    ...buttonBlock,
    mt: 2.5,
  },
};

export default styles;
